export const ALLOCATION_SECTION = 'allocation'
export const SECTIONS = [ALLOCATION_SECTION, 'performances', 'risk', 'summary']

export function cachedAnalyseBySection({ section, analyses, contractId }) {
  if (section === 'all') {
    if (
      analyses[contractId] &&
      JSON.stringify(Object.keys(analyses[contractId]).filter(key => SECTIONS.includes(key)).sort()) ===
        JSON.stringify(SECTIONS.sort())
    ) {
      return analyses[contractId]
    }
  } else {
    return analyses[contractId] && analyses[contractId][section]
  }
}
